import React from 'react'
import OnboardingSidebar from '../../layouts/OnboardingSidebar'
import QuestionSkipModal from './QuestionSkipModal'

function OnboardingLayout({ children }) {
    return (
        <div className="onboarding-wrap">
            <OnboardingSidebar />
            <div className="onboarding-screen">
                {children}
                <QuestionSkipModal />
            </div>
        </div>
    )
}

export default OnboardingLayout
